/**
 * Recharts renders raw SVG and needs literal color strings — it can't consume
 * Tailwind classes. These constants mirror `tailwind.config.js` 1:1 so chart
 * colors can never silently drift from the design system. If a token's hex
 * value changes there, update the matching entry here.
 */
export const CHART_COLORS = {
  accent: '#8B5CF6', // tailwind: accent
  surfaceElevated: '#161718', // tailwind: surfaceElevated
  borderStrong: '#2A2B2F', // tailwind: borderStrong
  textPrimary: '#F4F4F5', // tailwind: textPrimary
  mutedDim: '#646469', // tailwind: mutedDim
} as const;
